"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityAction = exports.Entity = void 0;
const index_js_1 = require("../errors/index.js");
const constants_js_1 = require("./constants.js");
const index_js_2 = require("./utils/index.js");
class Entity {
    constructor({ name, table, schema, computeKey, entityAttributeName = 'entity', entityAttributeHidden = true, timestamps = true }) {
        this.type = 'entity';
        this.name = name;
        this.table = table;
        this.entityAttributeName = entityAttributeName;
        this.entityAttributeHidden = entityAttributeHidden;
        this.timestamps = timestamps;
        if (computeKey === undefined && !(0, index_js_2.doesSchemaValidateTableSchema)(schema, table)) {
            throw new index_js_1.DynamoDBToolboxError('entity.invalidSchema', {
                message: `Entity ${name} schema does not follow its table primary key schema`
            });
        }
        this.constructorSchema = schema;
        this.schema = (0, index_js_2.addInternalAttributes)({
            schema,
            table: this.table,
            entityAttributeName: this.entityAttributeName,
            entityAttributeHidden: this.entityAttributeHidden,
            entityName: this.name,
            timestamps: this.timestamps
        });
        this.computeKey = computeKey;
    }
    build(Action) {
        return new Action(this);
    }
}
exports.Entity = Entity;
class EntityAction {
    constructor(entity) {
        this.entity = entity;
    }
}
exports.EntityAction = EntityAction;
